import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ApplePayButton.css';

export const APPLE_PAY_API_URL = 'https://www.kerambit.me/api/checkout/apple-pay';

/** iPhone / iPod / iPad, macOS и iPadOS 13+, который представляется как Macintosh. */
const APPLE_PLATFORM_PATTERN = /iPhone|iPod|iPad|Mac/i;

/**
 * Страница Apple Pay у провайдера заканчивается листом Apple Pay, поэтому на Windows и Android
 * кнопка была бы тупиком — показываем её только на платформах Apple (в любом браузере).
 */
export const isApplePayPlatform = () => {
  try {
    const platform = typeof navigator.platform === 'string' ? navigator.platform : '';
    const userAgent = typeof navigator.userAgent === 'string' ? navigator.userAgent : '';
    return APPLE_PLATFORM_PATTERN.test(platform) || APPLE_PLATFORM_PATTERN.test(userAgent);
  } catch (error) {
    // Защищённые браузеры могут бросать из геттеров navigator — остаёмся скрытыми.
    return false;
  }
};

/**
 * Кнопка Apple Pay для корзины (web redirect: оплата проходит на странице q-payments).
 *
 * Ничего не рисует, пока сервер не подтвердил, что Apple Pay включён, и на платформах не от Apple —
 * поэтому при обычном сценарии страница выглядит как раньше, а кнопка не мигает при загрузке.
 * Сам платёж запускает родитель через `onClick`: у него логин, согласие с условиями и корзина.
 */
const ApplePayButton = ({ disabled = false, loading = false, onClick }) => {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (!isApplePayPlatform()) return undefined;

    let cancelled = false;

    const loadConfig = async () => {
      try {
        const response = await axios.get(`${APPLE_PAY_API_URL}/config`);
        if (!cancelled && response.data && response.data.webRedirectEnabled === true) {
          setAvailable(true);
        }
      } catch (error) {
        // Apple Pay просто остаётся скрытым — оплата картой не затронута.
      }
    };

    loadConfig();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!available) return null;

  return (
    <div className="apple-pay-checkout">
      {/* type="button": на случай, если кнопку когда-нибудь поместят внутрь <form> */}
      <button
        type="button"
        lang="en"
        aria-label="Pay with Apple Pay"
        aria-busy={loading}
        disabled={disabled || loading}
        onClick={onClick}
        className="apple-pay-button apple-pay-button--black"
      />
      {loading && (
        <span className="apple-pay-checkout__status" role="status" aria-live="polite">
          <span className="apple-pay-checkout__spinner" />
        </span>
      )}
    </div>
  );
};

export default ApplePayButton;
